import { useState } from 'react';
import { S } from '@/shared/constants/styles';
import WelcomeStep from './WelcomeStep';
import BudgetModeStep from './BudgetModeStep';
import CategoryReviewStep from './CategoryReviewStep';

const STEPS = ['Welcome', 'Budget Mode', 'Categories'];

export default function OnboardingWizard({ theme: t, updateSettings, budgetMode }) {
  const [step, setStep] = useState(0);
  const [selectedMode, setSelectedMode] = useState(budgetMode || 'standard');

  const handleFinish = () => {
    updateSettings({ budgetMode: selectedMode, onboardingComplete: true }, { silent: true });
  };

  const handleModeChange = (mode) => {
    setSelectedMode(mode);
  };

  const isLast = step === STEPS.length - 1;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 100,
      background: t.bg,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 16,
    }}>
      <div style={{
        background: t.cardBg,
        borderRadius: 20,
        padding: '32px 28px',
        maxWidth: 480,
        width: '100%',
        boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
        border: '1px solid ' + t.cardBorder,
      }}>
        {/* Progress dots */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginBottom: 28 }}>
          {STEPS.map((_, i) => (
            <div
              key={i}
              style={{
                width: i === step ? 24 : 8,
                height: 8,
                borderRadius: 4,
                background: i === step ? '#2563eb' : (i < step ? '#2563eb' : t.cardBorder),
                opacity: i <= step ? 1 : 0.4,
                transition: 'all 0.3s',
              }}
            />
          ))}
        </div>

        {/* Step content */}
        {step === 0 && <WelcomeStep theme={t} />}
        {step === 1 && <BudgetModeStep theme={t} value={selectedMode} onChange={handleModeChange} />}
        {step === 2 && <CategoryReviewStep theme={t} />}

        {/* Navigation */}
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 28, gap: 12 }}>
          {step > 0 ? (
            <button
              onClick={() => setStep(step - 1)}
              style={{
                ...S.btn('transparent'),
                color: t.textMuted,
                border: '1px solid ' + t.cardBorder,
              }}
            >
              Back
            </button>
          ) : (
            <div />
          )}
          <button
            onClick={isLast ? handleFinish : () => setStep(step + 1)}
            style={S.btn()}
          >
            {isLast ? 'Get Started' : 'Next'}
          </button>
        </div>
      </div>
    </div>
  );
}
